<template>
  <div class="form-group">
    <label>{{ label }}</label>
    <div class="editor-toolbar">
      <button type="button" class="btn btn-secondary" @click="formatText('bold')">Fett</button>
      <button type="button" class="btn btn-secondary" @click="formatText('italic')">Kursiv</button>
      <button type="button" class="btn btn-secondary" @click="formatText('underline')">Unterstrichen</button>
      <button type="button" class="btn btn-secondary" @click="insertLink">Link</button>
      <button type="button" class="btn btn-secondary" @click="insertEmailLink">E-Mail-Link</button>
      <button type="button" class="btn btn-secondary" @click="formatText('unlink')">Link entfernen</button>
      <select class="font-picker" @change="applyFontFamily($event)">
        <option value="">Schriftart...</option>
        <option
          v-for="font in fontOptions"
          :key="font.value"
          :value="font.value"
          :style="{ fontFamily: font.value }"
        >
          {{ font.label }}
        </option>
      </select>
      <button v-if="allowList" type="button" class="btn btn-secondary" @click="formatText('insertUnorderedList')">Liste</button>
      <button v-if="allowHeadings" type="button" class="btn btn-secondary" @click="formatText('formatBlock', 'h2')">Überschrift</button>
      <button v-if="allowHeadings" type="button" class="btn btn-secondary" @click="formatText('formatBlock', 'p')">Absatz</button>
      <button type="button" class="btn btn-secondary" @click="formatText('removeFormat')">Format löschen</button>
    </div>
    <div
      ref="editor"
      class="rich-editor"
      :class="{ 'rich-editor-compact': compact }"
      contenteditable="true"
      @input="onInput"
    ></div>
    <small v-if="hint" class="editor-hint">{{ hint }}</small>
  </div>
</template>

<script>
export default {
  name: 'RichTextField',
  props: {
    modelValue: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    hint: {
      type: String,
      default: ''
    },
    compact: {
      type: Boolean,
      default: false
    },
    allowList: {
      type: Boolean,
      default: false
    },
    allowHeadings: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fontOptions: [
        { label: 'Avenir', value: 'Avenir' },
        { label: 'Segoe UI', value: 'Segoe UI' },
        { label: 'Arial', value: 'Arial' },
        { label: 'Roboto', value: 'Roboto' },
        { label: 'Open Sans', value: 'Open Sans' },
        { label: 'Lato', value: 'Lato' },
        { label: 'Montserrat', value: 'Montserrat' },
        { label: 'Poppins', value: 'Poppins' },
        { label: 'Inter', value: 'Inter' },
        { label: 'Merriweather', value: 'Merriweather' },
        { label: 'Playfair Display', value: 'Playfair Display' },
        { label: 'Pacifico', value: 'Pacifico' }
      ]
    };
  },
  mounted() {
    this.syncFromModel();
  },
  watch: {
    modelValue() {
      this.syncFromModel();
    }
  },
  methods: {
    syncFromModel() {
      const editor = this.$refs.editor;
      if (!editor) return;
      const nextValue = this.modelValue || '';
      if (editor.innerHTML !== nextValue) {
        editor.innerHTML = nextValue;
      }
    },
    onInput(event) {
      this.$emit('update:modelValue', event.target.innerHTML);
    },
    formatText(command, value = null) {
      const editor = this.$refs.editor;
      if (!editor) return;
      editor.focus();
      document.execCommand(command, false, value);
      this.$emit('update:modelValue', editor.innerHTML);
    },
    insertLink() {
      const url = window.prompt('Link-URL eingeben (z. B. https://example.de):', 'https://');
      if (!url) return;

      const trimmedUrl = url.trim();
      if (!trimmedUrl) return;

      const normalizedUrl = /^(https?:|mailto:|tel:)/i.test(trimmedUrl)
        ? trimmedUrl
        : `https://${trimmedUrl}`;

      this.formatText('createLink', normalizedUrl);
    },
    insertEmailLink() {
      const email = window.prompt('E-Mail-Adresse eingeben:', '');
      if (!email) return;

      const trimmedEmail = email.trim();
      if (!trimmedEmail) return;

      const normalizedEmail = trimmedEmail.toLowerCase().startsWith('mailto:')
        ? trimmedEmail
        : `mailto:${trimmedEmail}`;

      this.formatText('createLink', normalizedEmail);
    },
    applyFontFamily(event) {
      const fontFamily = event?.target?.value;
      if (!fontFamily) return;
      this.formatText('fontName', fontFamily);
      event.target.value = '';
    }
  }
};
</script>

<style scoped>
.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #333;
}

.editor-hint {
  display: block;
  color: #666;
  margin-top: 8px;
}

.editor-toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 10px;
}

.font-picker {
  padding: 8px 12px;
  border: 1px solid #bbb;
  border-radius: 4px;
  font-size: 14px;
  background: #fff;
  min-width: 170px;
}

.btn {
  padding: 8px 12px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.3s ease;
}

.btn-secondary {
  background: #666;
  color: white;
}

.btn-secondary:hover {
  background: #555;
}

.rich-editor {
  min-height: 260px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 12px;
  line-height: 1.5;
  overflow-wrap: anywhere;
}

.rich-editor-compact {
  min-height: 52px;
}

.rich-editor:focus {
  outline: 2px solid #8B4513;
  outline-offset: 1px;
}
</style>
